// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared visual details from the managerial dashboard; keep component layouts intact. */
:root {
    --app-background: #f1f6f9;
    --app-surface: #ffffff;
    --app-text: #1b3044;
    --app-muted: #6d8093;
    --app-primary: #104266;
    --app-border: #e0e9f0;
    --app-control-border: #cbdbe6;
    --app-selected: #e2eef7;
    --app-focus: #168ab5;
}

body {
    font-family: Roboto, Arial, sans-serif;
    color: var(--app-text);
    background: var(--app-background);
}

.card .card-header {
    --header-bg: var(--app-primary);
    box-shadow: 0 2px 6px rgba(16, 66, 102, 0.12);
}

.card .card-icon-button {
    background: transparent;
}

.card .card-icon-button:hover {
    background: rgba(255, 255, 255, 0.2);
}

.card .card-body {
    background: var(--app-background);
}

.card .profile-dropdown,
.profile-backdrop .profile-popup,
.inv-modal-overlay .inv-modal {
    border-radius: 10px;
    box-shadow: 0 8px 24px rgba(27, 48, 68, 0.14);
}

.card .profile-item:hover {
    background: var(--app-background);
}

.card .profile-divider {
    background: var(--app-border);
}

.card .item-list-tab {
    color: var(--app-muted);
    background: transparent;
    border-radius: 5px 5px 0 0;
    box-shadow: none;
}

.card .item-list-tab:hover {
    color: var(--app-primary);
    background: #edf3f7;
}

.card .item-list-tab.is-active {
    color: var(--app-primary);
    background: var(--app-selected);
    box-shadow: inset 0 -2px var(--app-primary);
}

.card .item-list-tab:focus-visible,
.floating-actions .floating-action-button:focus-visible {
    outline: 2px solid var(--app-focus);
    outline-offset: 2px;
}

.card .item-list-grid-wrapper .ag-root-wrapper {
    border-radius: 10px;
    color: var(--app-text);
    box-shadow: 0 0 0 1px var(--app-border);
}

.card .item-list-grid-wrapper .ag-header {
    background: #edf3f7;
    color: var(--app-primary);
    border-bottom-color: var(--app-border);
}

.card .item-list-toolbar select,
.card .role-selection-field select {
    color: var(--app-text);
    background-color: var(--app-surface);
    border-color: var(--app-control-border);
    border-radius: 6px;
}

.card :is(.nec-input, .stock-item-control1):not([type="checkbox"]):not([type="radio"]):not(:disabled):not([readonly]) {
    background-color: var(--app-surface);
    border-color: var(--app-control-border);
    color: var(--app-text);
}

.card :is(.nec-input, .stock-item-control1):not([type="checkbox"]):not([type="radio"]):not(:disabled):not([readonly]):focus-visible {
    border-color: var(--app-focus);
    outline: 2px solid var(--app-focus);
    outline-offset: 2px;
}

.card .user-select-add {
    --bg: var(--app-surface);
    --text: var(--app-text);
    --muted: var(--app-muted);
}

.card .stock-item-row {
    --row-bg: var(--app-surface);
    --text: var(--app-text);
    --muted: var(--app-muted);
    box-shadow: inset 0 0 0 1px var(--app-control-border);
}

.card .stock-empty {
    background: var(--app-surface);
    color: var(--app-muted);
    box-shadow: inset 0 0 0 1px var(--app-control-border);
}

.card .stock-item-control:focus-visible {
    outline: 2px solid var(--app-focus);
    outline-offset: 2px;
}

.card .idm {
    --text: var(--app-text);
    --muted: var(--app-muted);
}

.card .idm__left,
.card .idm__num:not(:disabled) {
    background-color: var(--app-surface);
    box-shadow: inset 0 0 0 1px var(--app-control-border);
}

.card .idm__num:focus-visible {
    outline: 2px solid var(--app-focus);
    outline-offset: 2px;
}

.card .user-select-add__box {
    box-shadow: inset 0 0 0 1px var(--app-control-border);
}

.card .user-select-add__box:focus-within {
    outline: 2px solid var(--app-focus);
    outline-offset: 2px;
}

.card :is(.deicing-form, .deicing-check-form) {
    font-family: inherit;
}

.card :is(.deicing-form, .deicing-check-form) .form-section {
    background: var(--app-surface);
    border-color: var(--app-border);
    border-radius: 10px;
}

.card :is(.deicing-form, .deicing-check-form) .form-section h3 {
    color: var(--app-primary);
    background: var(--app-selected);
    border-radius: 9px 9px 0 0;
}

.card :is(.deicing-form, .deicing-check-form) :is(input, select, textarea) {
    border-color: var(--app-control-border);
    border-radius: 5px;
}

.card :is(.deicing-form, .deicing-check-form) input[readonly] {
    background: #edf3f7;
}

.card :is(.deicing-form, .deicing-check-form) :is(input, select, textarea):focus-visible,
.card .item-list-toolbar select:focus-visible,
.card .role-selection-field select:focus-visible {
    outline: 2px solid var(--app-focus);
    outline-offset: 2px;
}

.floating-actions .floating-action-button {
    border-radius: 6px;
}

.card .select-module-button {
    font-family: inherit;
    font-size: 16px;
    font-weight: 500;
    color: var(--app-primary);
    background: var(--app-selected);
    border: 0;
    border-radius: 5px 5px 0 0;
    box-shadow: inset 0 -2px var(--app-primary);
}

.card .select-module-button:hover {
    background: #d4e5f1;
}

.card .select-module-button:focus-visible {
    outline: 2px solid var(--app-focus);
    outline-offset: 2px;
}

.login-page .login-submit {
    background: var(--app-primary);
    border-radius: 6px;
}

.login-page {
    background: var(--app-primary);
}

.login-page .login-card {
    border-radius: 10px;
    box-shadow: 0 12px 32px rgba(27, 48, 68, 0.2);
}

.login-page .login-input {
    border-color: var(--app-control-border);
    border-radius: 5px;
}

.login-page .login-input:focus {
    border-color: var(--app-focus);
    box-shadow: 0 0 0 2px rgba(22, 138, 181, 0.15);
}

.login-page .login-forgot {
    color: var(--app-primary);
}

@media (max-width: 767px) {
    /* Keep AG Grid's own filter and header controls within its row layout. */
    body :is(button, [role="button"]):not(.ag-root-wrapper *) {
        min-width: 52px;
        min-height: 52px;
        font-size: 17px;
        touch-action: manipulation;
    }

    body :is(input, select, textarea):not([type="checkbox"]):not([type="radio"]):not([type="hidden"]):not(.ag-root-wrapper *) {
        box-sizing: border-box;
        min-height: 52px;
        font-size: 17px;
    }

    body .card input:is([type="checkbox"], [type="radio"]):not(.ag-root-wrapper *) {
        width: 28px;
        height: 28px;
        min-width: 28px;
        padding: 0;
        margin: 0;
        transform: none;
        flex-shrink: 0;
    }

    body .card .checkbox-field {
        min-height: 52px;
        gap: 12px;
        align-items: center;
    }

    body .card .card-header {
        min-height: 64px;
        flex-shrink: 0;
    }

    body .card .card-header-title {
        font-size: 18px;
        white-space: normal;
    }

    body .card .card-icon-button {
        width: 52px;
        height: 52px;
    }

    body .card .profile-item {
        min-height: 52px;
        padding: 16px;
        font-size: 17px;
    }

    body .card .item-list-toolbar {
        flex-wrap: wrap;
        gap: 10px;
    }

    body .card .item-list-toolbar-right {
        max-width: 100%;
        flex-wrap: wrap;
        gap: 10px;
    }

    body .card .item-list-toolbar select {
        max-width: 100%;
        margin-left: 0;
    }

    body .date-time-input {
        grid-template-columns: minmax(0, 1fr) 4rem auto 4rem;
    }

    body .floating-actions {
        left: 12px;
        right: 12px;
        bottom: calc(12px + env(safe-area-inset-bottom, 0px));
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 10px;
        max-height: 40dvh;
        overflow-y: auto;
        z-index: 20;
    }

    body .floating-actions:has(> :only-child) {
        grid-template-columns: 1fr;
    }

    body .floating-actions .floating-action-button {
        justify-content: center;
        min-width: 0;
        min-height: 56px;
        height: auto;
        margin: 0;
        padding: 8px 10px;
        gap: 8px;
        font-size: 16px;
        line-height: 1.25;
        white-space: normal;
    }

    body .floating-actions .floating-action-icon {
        flex-shrink: 0;
        font-size: 20px;
    }

    body .floating-actions .floating-action-label {
        min-width: 0;
        overflow-wrap: anywhere;
    }

    /* Reserve space for the fixed actions in both lists and scrolling forms. */
    body .card:has(.floating-actions) {
        --mobile-action-height: 56px;
    }

    body .card:has(.floating-actions > :nth-child(3)) {
        --mobile-action-height: 122px;
    }

    body .card:has(.floating-actions > :nth-child(5)) {
        --mobile-action-height: 188px;
    }

    body .card:has(.floating-actions > :nth-child(7)) {
        --mobile-action-height: 254px;
    }

    body .card:has(.floating-actions) > .card-body {
        padding-bottom: calc(min(40dvh, var(--mobile-action-height)) + 28px + env(safe-area-inset-bottom, 0px));
    }

    body .inv-modal-actions1,
    body .inv-modal-actions,
    body .inv-modal-actions-left,
    body .inv-modal-actions-right {
        flex-wrap: wrap;
        gap: 12px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/web/entry/appearance.css"],"names":[],"mappings":"AAAA,wFAAwF;AACxF;IACI,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;IACtB,qBAAqB;IACrB,6BAA6B;IAC7B,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,sCAAsC;IACtC,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,+BAA+B;IAC/B,6CAA6C;AACjD;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;;;IAGI,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,+BAA+B;IAC/B,2CAA2C;AAC/C;;AAEA;;IAEI,mCAAmC;IACnC,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,uCAAuC;AAC3C;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,sCAAsC;AAC1C;;AAEA;;IAEI,sBAAsB;IACtB,oCAAoC;IACpC,uCAAuC;IACvC,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,uCAAuC;IACvC,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;IAC9B,mCAAmC;IACnC,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;IAC5B,uBAAuB;IACvB,yBAAyB;IACzB,qDAAqD;AACzD;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;IACvB,qDAAqD;AACzD;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;IACpC,qDAAqD;AACzD;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;AACvB;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;IAC9B,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,+BAA+B;IAC/B,0BAA0B;AAC9B;;AAEA;IACI,uCAAuC;IACvC,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;IAGI,mCAAmC;IACnC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,+BAA+B;IAC/B,SAAS;IACT,0BAA0B;IAC1B,2CAA2C;AAC/C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA;IACI,uCAAuC;IACvC,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,8CAA8C;AAClD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yEAAyE;IACzE;QACI,eAAe;QACf,gBAAgB;QAChB,eAAe;QACf,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,UAAU;QACV,SAAS;QACT,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,SAAS;QACT,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,SAAS;IACb;;IAEA;QACI,eAAe;QACf,eAAe;QACf,SAAS;IACb;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,oDAAoD;IACxD;;IAEA;QACI,UAAU;QACV,WAAW;QACX,qDAAqD;QACrD,aAAa;QACb,gDAAgD;QAChD,SAAS;QACT,iBAAiB;QACjB,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,uBAAuB;QACvB,YAAY;QACZ,gBAAgB;QAChB,YAAY;QACZ,SAAS;QACT,iBAAiB;QACjB,QAAQ;QACR,eAAe;QACf,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,uBAAuB;IAC3B;;IAEA,2EAA2E;IAC3E;QACI,4BAA4B;IAChC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,uGAAuG;IAC3G;;IAEA;;;;QAII,eAAe;QACf,SAAS;IACb;AACJ","sourcesContent":["/* Shared visual details from the managerial dashboard; keep component layouts intact. */\n:root {\n    --app-background: #f1f6f9;\n    --app-surface: #ffffff;\n    --app-text: #1b3044;\n    --app-muted: #6d8093;\n    --app-primary: #104266;\n    --app-border: #e0e9f0;\n    --app-control-border: #cbdbe6;\n    --app-selected: #e2eef7;\n    --app-focus: #168ab5;\n}\n\nbody {\n    font-family: Roboto, Arial, sans-serif;\n    color: var(--app-text);\n    background: var(--app-background);\n}\n\n.card .card-header {\n    --header-bg: var(--app-primary);\n    box-shadow: 0 2px 6px rgba(16, 66, 102, 0.12);\n}\n\n.card .card-icon-button {\n    background: transparent;\n}\n\n.card .card-icon-button:hover {\n    background: rgba(255, 255, 255, 0.2);\n}\n\n.card .card-body {\n    background: var(--app-background);\n}\n\n.card .profile-dropdown,\n.profile-backdrop .profile-popup,\n.inv-modal-overlay .inv-modal {\n    border-radius: 10px;\n    box-shadow: 0 8px 24px rgba(27, 48, 68, 0.14);\n}\n\n.card .profile-item:hover {\n    background: var(--app-background);\n}\n\n.card .profile-divider {\n    background: var(--app-border);\n}\n\n.card .item-list-tab {\n    color: var(--app-muted);\n    background: transparent;\n    border-radius: 5px 5px 0 0;\n    box-shadow: none;\n}\n\n.card .item-list-tab:hover {\n    color: var(--app-primary);\n    background: #edf3f7;\n}\n\n.card .item-list-tab.is-active {\n    color: var(--app-primary);\n    background: var(--app-selected);\n    box-shadow: inset 0 -2px var(--app-primary);\n}\n\n.card .item-list-tab:focus-visible,\n.floating-actions .floating-action-button:focus-visible {\n    outline: 2px solid var(--app-focus);\n    outline-offset: 2px;\n}\n\n.card .item-list-grid-wrapper .ag-root-wrapper {\n    border-radius: 10px;\n    color: var(--app-text);\n    box-shadow: 0 0 0 1px var(--app-border);\n}\n\n.card .item-list-grid-wrapper .ag-header {\n    background: #edf3f7;\n    color: var(--app-primary);\n    border-bottom-color: var(--app-border);\n}\n\n.card .item-list-toolbar select,\n.card .role-selection-field select {\n    color: var(--app-text);\n    background-color: var(--app-surface);\n    border-color: var(--app-control-border);\n    border-radius: 6px;\n}\n\n.card :is(.nec-input, .stock-item-control1):not([type=\"checkbox\"]):not([type=\"radio\"]):not(:disabled):not([readonly]) {\n    background-color: var(--app-surface);\n    border-color: var(--app-control-border);\n    color: var(--app-text);\n}\n\n.card :is(.nec-input, .stock-item-control1):not([type=\"checkbox\"]):not([type=\"radio\"]):not(:disabled):not([readonly]):focus-visible {\n    border-color: var(--app-focus);\n    outline: 2px solid var(--app-focus);\n    outline-offset: 2px;\n}\n\n.card .user-select-add {\n    --bg: var(--app-surface);\n    --text: var(--app-text);\n    --muted: var(--app-muted);\n}\n\n.card .stock-item-row {\n    --row-bg: var(--app-surface);\n    --text: var(--app-text);\n    --muted: var(--app-muted);\n    box-shadow: inset 0 0 0 1px var(--app-control-border);\n}\n\n.card .stock-empty {\n    background: var(--app-surface);\n    color: var(--app-muted);\n    box-shadow: inset 0 0 0 1px var(--app-control-border);\n}\n\n.card .stock-item-control:focus-visible {\n    outline: 2px solid var(--app-focus);\n    outline-offset: 2px;\n}\n\n.card .idm {\n    --text: var(--app-text);\n    --muted: var(--app-muted);\n}\n\n.card .idm__left,\n.card .idm__num:not(:disabled) {\n    background-color: var(--app-surface);\n    box-shadow: inset 0 0 0 1px var(--app-control-border);\n}\n\n.card .idm__num:focus-visible {\n    outline: 2px solid var(--app-focus);\n    outline-offset: 2px;\n}\n\n.card .user-select-add__box {\n    box-shadow: inset 0 0 0 1px var(--app-control-border);\n}\n\n.card .user-select-add__box:focus-within {\n    outline: 2px solid var(--app-focus);\n    outline-offset: 2px;\n}\n\n.card :is(.deicing-form, .deicing-check-form) {\n    font-family: inherit;\n}\n\n.card :is(.deicing-form, .deicing-check-form) .form-section {\n    background: var(--app-surface);\n    border-color: var(--app-border);\n    border-radius: 10px;\n}\n\n.card :is(.deicing-form, .deicing-check-form) .form-section h3 {\n    color: var(--app-primary);\n    background: var(--app-selected);\n    border-radius: 9px 9px 0 0;\n}\n\n.card :is(.deicing-form, .deicing-check-form) :is(input, select, textarea) {\n    border-color: var(--app-control-border);\n    border-radius: 5px;\n}\n\n.card :is(.deicing-form, .deicing-check-form) input[readonly] {\n    background: #edf3f7;\n}\n\n.card :is(.deicing-form, .deicing-check-form) :is(input, select, textarea):focus-visible,\n.card .item-list-toolbar select:focus-visible,\n.card .role-selection-field select:focus-visible {\n    outline: 2px solid var(--app-focus);\n    outline-offset: 2px;\n}\n\n.floating-actions .floating-action-button {\n    border-radius: 6px;\n}\n\n.card .select-module-button {\n    font-family: inherit;\n    font-size: 16px;\n    font-weight: 500;\n    color: var(--app-primary);\n    background: var(--app-selected);\n    border: 0;\n    border-radius: 5px 5px 0 0;\n    box-shadow: inset 0 -2px var(--app-primary);\n}\n\n.card .select-module-button:hover {\n    background: #d4e5f1;\n}\n\n.card .select-module-button:focus-visible {\n    outline: 2px solid var(--app-focus);\n    outline-offset: 2px;\n}\n\n.login-page .login-submit {\n    background: var(--app-primary);\n    border-radius: 6px;\n}\n\n.login-page {\n    background: var(--app-primary);\n}\n\n.login-page .login-card {\n    border-radius: 10px;\n    box-shadow: 0 12px 32px rgba(27, 48, 68, 0.2);\n}\n\n.login-page .login-input {\n    border-color: var(--app-control-border);\n    border-radius: 5px;\n}\n\n.login-page .login-input:focus {\n    border-color: var(--app-focus);\n    box-shadow: 0 0 0 2px rgba(22, 138, 181, 0.15);\n}\n\n.login-page .login-forgot {\n    color: var(--app-primary);\n}\n\n@media (max-width: 767px) {\n    /* Keep AG Grid's own filter and header controls within its row layout. */\n    body :is(button, [role=\"button\"]):not(.ag-root-wrapper *) {\n        min-width: 52px;\n        min-height: 52px;\n        font-size: 17px;\n        touch-action: manipulation;\n    }\n\n    body :is(input, select, textarea):not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"hidden\"]):not(.ag-root-wrapper *) {\n        box-sizing: border-box;\n        min-height: 52px;\n        font-size: 17px;\n    }\n\n    body .card input:is([type=\"checkbox\"], [type=\"radio\"]):not(.ag-root-wrapper *) {\n        width: 28px;\n        height: 28px;\n        min-width: 28px;\n        padding: 0;\n        margin: 0;\n        transform: none;\n        flex-shrink: 0;\n    }\n\n    body .card .checkbox-field {\n        min-height: 52px;\n        gap: 12px;\n        align-items: center;\n    }\n\n    body .card .card-header {\n        min-height: 64px;\n        flex-shrink: 0;\n    }\n\n    body .card .card-header-title {\n        font-size: 18px;\n        white-space: normal;\n    }\n\n    body .card .card-icon-button {\n        width: 52px;\n        height: 52px;\n    }\n\n    body .card .profile-item {\n        min-height: 52px;\n        padding: 16px;\n        font-size: 17px;\n    }\n\n    body .card .item-list-toolbar {\n        flex-wrap: wrap;\n        gap: 10px;\n    }\n\n    body .card .item-list-toolbar-right {\n        max-width: 100%;\n        flex-wrap: wrap;\n        gap: 10px;\n    }\n\n    body .card .item-list-toolbar select {\n        max-width: 100%;\n        margin-left: 0;\n    }\n\n    body .date-time-input {\n        grid-template-columns: minmax(0, 1fr) 4rem auto 4rem;\n    }\n\n    body .floating-actions {\n        left: 12px;\n        right: 12px;\n        bottom: calc(12px + env(safe-area-inset-bottom, 0px));\n        display: grid;\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n        gap: 10px;\n        max-height: 40dvh;\n        overflow-y: auto;\n        z-index: 20;\n    }\n\n    body .floating-actions:has(> :only-child) {\n        grid-template-columns: 1fr;\n    }\n\n    body .floating-actions .floating-action-button {\n        justify-content: center;\n        min-width: 0;\n        min-height: 56px;\n        height: auto;\n        margin: 0;\n        padding: 8px 10px;\n        gap: 8px;\n        font-size: 16px;\n        line-height: 1.25;\n        white-space: normal;\n    }\n\n    body .floating-actions .floating-action-icon {\n        flex-shrink: 0;\n        font-size: 20px;\n    }\n\n    body .floating-actions .floating-action-label {\n        min-width: 0;\n        overflow-wrap: anywhere;\n    }\n\n    /* Reserve space for the fixed actions in both lists and scrolling forms. */\n    body .card:has(.floating-actions) {\n        --mobile-action-height: 56px;\n    }\n\n    body .card:has(.floating-actions > :nth-child(3)) {\n        --mobile-action-height: 122px;\n    }\n\n    body .card:has(.floating-actions > :nth-child(5)) {\n        --mobile-action-height: 188px;\n    }\n\n    body .card:has(.floating-actions > :nth-child(7)) {\n        --mobile-action-height: 254px;\n    }\n\n    body .card:has(.floating-actions) > .card-body {\n        padding-bottom: calc(min(40dvh, var(--mobile-action-height)) + 28px + env(safe-area-inset-bottom, 0px));\n    }\n\n    body .inv-modal-actions1,\n    body .inv-modal-actions,\n    body .inv-modal-actions-left,\n    body .inv-modal-actions-right {\n        flex-wrap: wrap;\n        gap: 12px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
